import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button/button';
import Icon from '../icon/icon';
import SidebarItem from './sidebaritem';
import CollapsibleItem from './collapsibleitem';
import './style';
import { CheckCircle } from '@phosphor-icons/react';

const Sidebar = (props) => {
  const { 
    banner, 
    checkItems,
    children,
    className, 
    colorMode, 
    header, 
    menuItems,
    onMenuClick, 
    selectedItem, 
    width,  
  } = props;
  return (
    <div className={`sidebar ${className} flex flex-col gap-4 border-r border-grey-10 overflow-auto`}
      style={{ width }}
    >

      {header &&
      <div> {header}</div> }
      <div className='flex flex-col gap-3  '> 
        {!!menuItems?.length && (
        <div className='border-b border-grey-10 pb-6'> 
          {menuItems.map((item, index) => (
            <SidebarItem
              key={index}
              label={item.label}
              icon={item.icon}
              onClick={() => onMenuClick(item)}
              isSelected={typeof selectedItem === 'string' ? (selectedItem === item.value) : (selectedItem?.value === item.value)}
              colorMode={colorMode}
            />
          ))}
        </div>)}
        {checkItems && checkItems.map((checkItem, index)=>(
          checkItem.subItems ? ( <CollapsibleItem
            key={index}
            label={checkItem.label}
            icon={checkItem.check? <CheckCircle size={24} 
              weight='fill' /> : checkItem.icon}
            subItems={checkItem.subItems}
            colorMode={colorMode}
            onMenuClick={onMenuClick}
            selectedItem = {selectedItem}
          />
          ) : (
            <SidebarItem
              key={index}
              label={checkItem.label}
              icon={checkItem.check? <CheckCircle size={24} 
                weight='fill' /> : checkItem.icon}
              onClick={() => onMenuClick(checkItem)}
              isSelected = {selectedItem === checkItem}
              colorMode={colorMode}
            />
          ) ))}
      </div>
      {banner && (
        <div className='banner-content bg-grey-5 p-4 flex flex-col gap-4 w-full' >
          <div className='flex flex-col gap-4'> 
            {banner.icon && 
            <Icon children={banner.icon}
              type='square'
            />}
            <div className='flex flex-col gap-2'>
              {banner.heading &&  <div className='heading-16'> {banner.heading}</div>}
              {banner.content && <div className='text-14'>{banner.content}</div>}
            </div>
          </div>
          {banner.cta && <Button type='primary-black' 
            size='small'
            children={banner.cta}
            className='cta '
            onClick={banner.ctaLink}
          />}
        </div>
      )}
      {children && <div className="content">{children}</div>}
    </div>
  );
};

Sidebar.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      content: PropTypes.node,
      onClick: PropTypes.func,
    }),
  ).isRequired,
  onMenuClick: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  className: PropTypes.string,
  banner: PropTypes.shape({
    icon: PropTypes.node,
    heading: PropTypes.string,
    content: PropTypes.node,
    cta: PropTypes.string,
    ctaLink: PropTypes.string,
  }),
  collapsibleItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      subItems: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          icon: PropTypes.node,
          onClick: PropTypes.func.isRequired,
          isSelected: PropTypes.bool.isRequired,
        }),
      ).isRequired,
    }),
  ),
  checkItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      content: PropTypes.node,
      onClick: PropTypes.func,
    }),
  ),
  children: PropTypes.node,
  width: PropTypes.string.isRequired,
  colorMode: PropTypes.oneOf(['grey-to-black', 'black']),
};

Sidebar.defaultProps = {
  menuItems: [],
  onMenuClick: () => {},
  selectedItem: null,
  className: '',
  banner: null,
  header: null,
  collapsibleItems: [],
  checkItems:[],
  children: null,
  className: '',
  colorMode:'grey-to-black',
  header: null,
  width:'300',
};

export default Sidebar;